import { render, staticRenderFns } from "./ROI.vue?vue&type=template&id=1a2c31a5&scoped=true&"
import script from "./ROI.vue?vue&type=script&lang=js&"
export * from "./ROI.vue?vue&type=script&lang=js&"
import style0 from "./ROI.vue?vue&type=style&index=0&id=1a2c31a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c31a5",
  null
  
)

export default component.exports